import axios from "axios";

function base(eventId) {
  return `${process.env.REACT_APP_API}/evento/${eventId}/mensagens`;
}

export async function listarModelosMensagem(eventId) {
  const res = await axios.get(`${base(eventId)}/modelos`);
  return res.data || [];
}

export async function salvarModeloMensagem(eventId, modelo) {
  if (modelo.id) {
    const res = await axios.put(`${base(eventId)}/modelos/${modelo.id}`, modelo);
    return res.data;
  }

  const res = await axios.post(`${base(eventId)}/modelos`, modelo);
  return res.data;
}

export async function excluirModeloMensagem(eventId, modeloId) {
  await axios.delete(`${base(eventId)}/modelos/${modeloId}`);
}

export async function listarAgendamentosMensagem(eventId) {
  const res = await axios.get(`${base(eventId)}/agendamentos`);
  return res.data || [];
}

export async function salvarAgendamentoMensagem(eventId, agendamento) {
  if (agendamento.id) {
    const res = await axios.put(`${base(eventId)}/agendamentos/${agendamento.id}`, agendamento);
    return res.data;
  }

  const res = await axios.post(`${base(eventId)}/agendamentos`, agendamento);
  return res.data;
}

export async function excluirAgendamentoMensagem(eventId, agendamentoId) {
  await axios.delete(`${base(eventId)}/agendamentos/${agendamentoId}`);
}

export async function cancelarAgendamentoMensagem(eventId, agendamentoId) {
  await axios.post(`${base(eventId)}/agendamentos/${agendamentoId}/cancelar`);
}

export async function processarAgendamentoMensagem(eventId, agendamentoId) {
  const res = await axios.post(`${base(eventId)}/agendamentos/${agendamentoId}/processar`);
  return res.data;
}
